import { render } from "./AddSSHCollectorMedicrossSite.vue?vue&type=template&id=75268032"
import script from "./AddSSHCollectorMedicrossSite.vue?vue&type=script&lang=js"
export * from "./AddSSHCollectorMedicrossSite.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__